const QUIZ_THEMES = {
  dark:   { bg: '#1C1C1E', accent: '#5B8A75', text: '#FFFFFF', surface: '#2C2C2E', border: '#3A3A3C' },
  green:  { bg: '#0D2B1F', accent: '#5B8A75', text: '#FFFFFF', surface: '#153D2C', border: '#1F5039' },
  blue:   { bg: '#0D1B2A', accent: '#4A90D9', text: '#FFFFFF', surface: '#152535', border: '#1E3650' },
  purple: { bg: '#1A0D2B', accent: '#9B59B6', text: '#FFFFFF', surface: '#251540', border: '#3A2055' },
  brown:  { bg: '#2A1E0D', accent: '#C17B5C', text: '#FFFFFF', surface: '#3A2B18', border: '#503C25' },
  light:  { bg: '#F7F5F0', accent: '#5B8A75', text: '#1C1C1E', surface: '#FFFFFF',  border: '#E5E0D8' },
};

export default QUIZ_THEMES;
